{
  "en": {
    "ticket_category": {
      "Decisions": "Decision",
      "Issue": "Aftercare",
      "Other": "Regular",
      "actions": {
        "delete": "Remove conversation category"
      },
      "inputs": {
        "empty": "No category"
      },
      "labels": {
        "delete": "Remove {category}",
        "delete_description": "Are you sure you want to remove {category} from your conversation categories?",
        "ticket_categories": "Categories",
        "ticket_category": "Type"
      }
    }
  }
}